import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import { canUseTheHub, totalHubUnread, useTheHubLive } from "../theHub";

export function useHubUnread() {
  const { session } = useAuth();
  const [count, setCount] = useState(0);

  function refresh() {
    setCount(canUseTheHub(session) ? totalHubUnread(session) : 0);
  }

  useTheHubLive(refresh);
  useEffect(() => {
    refresh();
  }, [session]);

  return count;
}
